import ctiProfile from './firms/cti/profile.json';
import ctiDiscount from './firms/cti/discount.json';
import ctiPricing from './firms/cti/pricing.json';

import ttpProfile from './firms/ttp/profile.json';
import ttpDiscount from './firms/ttp/discount.json';
import ttpPricing from './firms/ttp/pricing.json';

import e8Profile from './firms/e8/profile.json';
import e8Discount from './firms/e8/discount.json';
import e8Pricing from './firms/e8/pricing.json';

import fxifyProfile from './firms/fxify/profile.json';
import fxifyDiscount from './firms/fxify/discount.json';
import fxifyPricing from './firms/fxify/pricing.json';

import alphaProfile from './firms/alpha-capital/profile.json';
import alphaDiscount from './firms/alpha-capital/discount.json';
import alphaPricing from './firms/alpha-capital/pricing.json';

import forTradersProfile from './firms/for-traders/profile.json';
import forTradersDiscount from './firms/for-traders/discount.json';
import forTradersPricing from './firms/for-traders/pricing.json';

import seacrestProfile from './firms/seacrest-funded/profile.json';
import seacrestDiscount from './firms/seacrest-funded/discount.json';
import seacrestPricing from './firms/seacrest-funded/pricing.json';

import tradingPlusProfile from './firms/tradingplus/profile.json';
import tradingPlusDiscount from './firms/tradingplus/discount.json';
import tradingPlusPricing from './firms/tradingplus/pricing.json';

import wmtProfile from './firms/wmt/profile.json';
import wmtDiscount from './firms/wmt/discount.json';
import wmtPricing from './firms/wmt/pricing.json';

import blueberryfundedProfile from './firms/blueberryfunded/profile.json';
import blueberryfundedDiscount from './firms/blueberryfunded/discount.json';
import blueberryfundedPricing from './firms/blueberryfunded/pricing.json';

import tentradeProfile from './firms/tentrade/profile.json';
import tentradeDiscount from './firms/tentrade/discount.json';
import tentradePricing from './firms/tentrade/pricing.json';

import hyrotraderProfile from './firms/hyrotrader/profile.json';
import hyrotraderDiscount from './firms/hyrotrader/discount.json';
import hyrotraderPricing from './firms/hyrotrader/pricing.json';

import onefundedProfile from './firms/onefunded/profile.json';
import onefundedDiscount from './firms/onefunded/discount.json';
import onefundedPricing from './firms/onefunded/pricing.json';

const normalizePricing = (pricing: unknown) => {
  const p = pricing as any;
  return p?.challenges ?? (Array.isArray(pricing) ? pricing : []);
};

export const propFirmData = {
  cti: {
    ...ctiProfile,
    evaluation: {
      ...ctiProfile.evaluation,
      discount: ctiDiscount,
    },
    pricing: normalizePricing(ctiPricing),
  },
  ttp: {
    ...ttpProfile,
    evaluation: {
      ...ttpProfile.evaluation,
      discount: ttpDiscount,
    },
    pricing: normalizePricing(ttpPricing),
  },
  e8: {
    ...e8Profile,
    evaluation: {
      ...e8Profile.evaluation,
      discount: e8Discount,
    },
    pricing: normalizePricing(e8Pricing),
  },
  fxify: {
    ...fxifyProfile,
    evaluation: {
      ...fxifyProfile.evaluation,
      discount: fxifyDiscount,
    },
    pricing: normalizePricing(fxifyPricing),
  },
  'alpha-capital': {
    ...alphaProfile,
    evaluation: {
      ...alphaProfile.evaluation,
      discount: alphaDiscount,
    },
    pricing: normalizePricing(alphaPricing),
  },
  'for-traders': {
    ...forTradersProfile,
    evaluation: {
      ...forTradersProfile.evaluation,
      discount: forTradersDiscount,
    },
    pricing: normalizePricing(forTradersPricing),
  },
  'seacrest-funded': {
    ...seacrestProfile,
    evaluation: {
      ...seacrestProfile.evaluation,
      discount: seacrestDiscount,
    },
    pricing: normalizePricing(seacrestPricing),
  },
  tradingplus: {
    ...tradingPlusProfile,
    evaluation: {
      ...tradingPlusProfile.evaluation,
      discount: tradingPlusDiscount,
    },
    pricing: normalizePricing(tradingPlusPricing),
  },
  wmt: {
    ...wmtProfile,
    evaluation: {
      ...wmtProfile.evaluation,
      discount: wmtDiscount,
    },
    pricing: normalizePricing(wmtPricing),
  },
  blueberryfunded: {
    ...blueberryfundedProfile,
    evaluation: {
      ...blueberryfundedProfile.evaluation,
      discount: blueberryfundedDiscount,
    },
    pricing: normalizePricing(blueberryfundedPricing),
  },
  tentrade: {
    ...tentradeProfile,
    evaluation: {
      ...tentradeProfile.evaluation,
      discount: tentradeDiscount,
    },
    pricing: normalizePricing(tentradePricing),
  },
  hyrotrader: {
    ...hyrotraderProfile,
    evaluation: {
      ...hyrotraderProfile.evaluation,
      discount: hyrotraderDiscount,
    },
    pricing: normalizePricing(hyrotraderPricing),
  },
  onefunded: {
    ...onefundedProfile,
    evaluation: {
      ...onefundedProfile.evaluation,
      discount: onefundedDiscount,
    },
    pricing: normalizePricing(onefundedPricing),
  },
};
